
  <div class="dropdown-menu show" >
    <button class="dropdown-item" (click)="handleClick('1')"><i class="fa fa-edit m-1"></i>{{ edit }}</button>
    <button class="dropdown-item" (click)="handleClick('-1')"> <i class="fa fa-remove m-1"></i>{{ delete }}</button>
  </div>
  